import { z } from 'zod';

const baseStringSchema = z.union([z.string().trim(), z.number()]).nullish();

export function sessionCreateSchema(t, privateSession) {
    return z.object({
        session_id: z
            .string()
            .min(1, {
                message: t('form.required_field'),
            })
            .uuid({
                message: t('form.uuid_is_wrong'),
            }),
        session_name: baseStringSchema.refine(sessionNameRefineCallback, () => ({ message: t('form.required_field') })),
        video_url: baseStringSchema.refine(videoURLRefineCallback, (val) => ({ message: `${val ? t('create_session.errors.wrong_youtube_link') : t('form.required_field')}` })),
        token_url: baseStringSchema.refine(tokenURLRefineCallback, (val) => ({ message: `${val ? t('form.url_is_wrong') : t('form.required_field')}` })),
        auth: baseStringSchema.refine(authTokenRefineCallback, () => ({ message: t('form.required_field') })),
        duration: baseStringSchema.refine(durationRefineCallback, () => ({ message: t('form.required_field') })),
        base_score: baseStringSchema.refine(checkToValueAndHigherZero, (val) => ({ message: `${!val ? t('form.required_field') : t('form.positive_number_is_wrong')}` })),
        locale: baseStringSchema.refine(localeRefineCallback, () => ({ message: t('form.required_field') })),
        redirect_url: baseStringSchema.refine(redirectURLRefineCallback, (val) => ({ message: `${val ? t('form.url_is_wrong') : t('form.required_field')}` })),
        iframe_url: baseStringSchema.refine(iframeURLRefineCallback, (val) => ({ message: `${val ? t('form.url_is_wrong') : t('form.required_field')}` })),
    });

    function sessionNameRefineCallback(val) {
        return !!val;
    }

    function durationRefineCallback(val) {
        return !!val;
    }

    function videoURLRefineCallback(val) {
        const regex = /^https:\/\/(www\.)?youtube\.com\/watch\?v=/;
        return !!val && regex.test(val);
    }

    function tokenURLRefineCallback(val) {
        if (privateSession.value) {
            const urlSchema = z.string().url();

            return !!val ? urlSchema.safeParse(val).success : false;
        } else {
            return true;
        }
    }

    function iframeURLRefineCallback(val) {
        const urlSchema = z.string().url();
        return val ? urlSchema.safeParse(val).success : false;
    }

    function redirectURLRefineCallback(val) {
        const urlSchema = z.string().url();

        return !!val ? urlSchema.safeParse(val).success : false;
    }

    function authTokenRefineCallback(val) {
        return privateSession.value ? !!val : true;
    }

    function checkToValueAndHigherZero(val) {
        return !!val && val > 0;
    }

    function localeRefineCallback(val) {
        return !!val;
    }
}
